document.addEventListener('DOMContentLoaded', async () => {
  const kitItems = document.querySelectorAll('.kit-item');
  
  if (kitItems.length === 0) return;
  
  // Show skeleton loaders
  kitItems.forEach(item => {
    const imageContainer = item.querySelector('.js-kit-image');
    const contentVendor = item.querySelector('.js-kit-content-vendor');
    const contentTitle = item.querySelector('.js-kit-content-title');
    
    if (imageContainer) {
      imageContainer.innerHTML = '<div class="skeleton skeleton--image"></div>';
    }
    if (contentVendor) {
      contentVendor.innerHTML = '<div class="skeleton skeleton--text skeleton--text-short"></div>';
    }
    if (contentTitle) {
      contentTitle.innerHTML = '<div class="skeleton skeleton--text"></div><div class="skeleton skeleton--text skeleton--text-short"></div>';
    }
  });
  
  // Collect all SKUs from the page
  const skus = Array.from(kitItems).map(item => item.dataset.kitSku).filter(Boolean);
  
  if (skus.length === 0) return;
  
  // Get current locale from Shopify
  const locale = window.Shopify?.locale || 'nl';
  
  try {
    // Fetch product data from API
    const response = await fetch(
      `https://${window.location.hostname !== '127.0.0.1' ? window.location.hostname : 'ecostal-development.myshopify.com'}/apps/ecostal/api/skus?skus=${skus.join(',')}&locale=${locale}`
    );
    
    if (!response.ok) {
      throw new Error('API request failed');
    }
    
    const data = await response.json();
    
    if (!data.success) {
      console.error('API returned error:', data);
      return;
    }
    
    // Create a map of SKU to product data for quick lookup
    const productMap = new Map(
      data.products.map(product => [product.sku, product])
    );
    
    // Update each kit item with product data
    kitItems.forEach(item => {
      const sku = item.dataset.kitSku;
      const product = productMap.get(sku);
      
      if (!product) {
        // Remove skeleton loaders if no product found
        item.querySelectorAll('.skeleton').forEach(el => el.remove());
        return;
      }
      
      // Update the image
      const imageContainer = item.querySelector('.js-kit-image');
      if (imageContainer && product.imageUrl) {
        imageContainer.innerHTML = `<img src="${product.imageUrl}&width=100" alt="${product.title}" class="kit-image">`;
      }
      
      // Update the vendor
      const vendorContainer = item.querySelector('.js-kit-content-vendor');
      if (vendorContainer && product.vendor) {
        vendorContainer.innerHTML = `<p class="kit-vendor">${product.vendor}</p>`;
      }
      
      // Update the title
      const titleContainer = item.querySelector('.js-kit-content-title');
      if (titleContainer && product.title) {
        titleContainer.innerHTML = `<p class="kit-title">${product.title}</p>`;
      }
      
      // Update the link
      const link = item.querySelector('.kit-link');
      if (link && product.onlineStoreUrl !== null) {
        link.href = product.onlineStoreUrl;
        link.target = '_blank';
      } else {
        if (product.handle) {
          link.href = `/${locale}/products/${product.handle}`;
          link.target = '_blank';
        }
      }
      
      item.querySelectorAll('.skeleton').forEach(el => el.classList.remove('skeleton'));
    });
    
  } catch (error) {
    console.error('Error fetching composition kit data:', error);
    // Remove skeleton loaders on error
    kitItems.forEach(item => {
      item.querySelectorAll('.skeleton').forEach(el => el.remove());
    });
  }
});
